import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import Card from 'honeydew/Card';
import { useAccountPlusMembershipHook } from 'hooks/useAccountPlusMembershipHook';

import { BenefitsList } from '../BenefitsList';

export function BenefitsCard({ showViewMembershipLink }) {
    const { membership, plusMembershipBranding, trial } = useAccountPlusMembershipHook();

    return (
        <Card topGradientBorder>
            <div className="flex flex-col gap-20">
                <h4 className="text-body-md font-grotesk-bold">
                    {membership || trial ? `Your ${plusMembershipBranding} Benefits` : 'Members-only benefits'}
                </h4>
                <BenefitsList />
                {showViewMembershipLink && (
                    <Link className="link-blueberry text-body-sm block" to="/account/membership">
                        View my membership
                    </Link>
                )}
            </div>
        </Card>
    );
}

BenefitsCard.propTypes = {
    showViewMembershipLink: PropTypes.bool,
};

BenefitsCard.defaultProps = {
    showViewMembershipLink: true,
};
